import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, DatePropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { DataView } from "./data-view"
import { getAsBoolean } from "src/uicomponents/components/utilities";

export class DateSelectorComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Date Selector';
        this.addProperty("Date","data-b-comp-date",new DatePropertyType(this),null,false);
        this.addProperty("AllowClear","data-b-comp-allowclear",new BooleanPropertyType(this),true,false);
        this.addProperty("StartWithYear","data-b-comp-startwithyear",new BooleanPropertyType(this),false,false);
        this.addProperty("OpenTop","data-b-comp-opentop",new BooleanPropertyType(this),false,false);
        this.addProperty("TimeSelector","data-b-comp-timeselector",new BooleanPropertyType(this),false,false);
        this.addProperty("DateSelector","data-b-comp-dateselector",new BooleanPropertyType(this),true,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new DataViewModel(parent);
        return result;
    }
        
}
export class DataViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new DataView();
    }
    public getTypeId(): string {
        return "VM-C63DCED0-7418-4B16-8518-84B83BA60080"
    }
    public set Date(v: moment.Moment) { this._Date = v; } public get Date(): moment.Moment { return this._Date;} private _Date: moment.Moment;
    public set AllowClear(v: boolean) { this._AllowClear = v; } public get AllowClear(): boolean { return this._AllowClear;} private _AllowClear: boolean;
    public set StartWithYear(v: boolean) { this._StartWithYear = v; } public get StartWithYear(): boolean { return this._StartWithYear;} private _StartWithYear: boolean;
    public set OpenTop(v: boolean) { this._OpenTop = v; } public get OpenTop(): boolean { return this._OpenTop;} private _OpenTop: boolean;
    public set TimeSelector(v: boolean) { this._TimeSelector = getAsBoolean(v); } public get TimeSelector(): boolean { return this._TimeSelector;} private _TimeSelector: boolean;
    public set DateSelector(v: boolean) { this._DateSelector = getAsBoolean(v); } public get DateSelector(): boolean { return this._DateSelector;} private _DateSelector: boolean;
    
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitDate(this,parameter);
    }

}
